import { loadablePlayerSelectedGamesForQueryAtom } from '@/atoms/filters/player/playerGames';
import { playerRenderedComparisonSourceAtom } from '@/atoms/queries/player/playerLeagueAverageRadar';
import { loadablePlayerRadarDataAtom } from '@/atoms/queries/player/playerRadar';
import { RadarChart } from '@/components/radar/RadarChart';
import { SBID } from '@/types/generic';

export const PlayerRadarChart = ({
  id,
  isWidget,
  isInteractive,
}: {
  id: SBID;
  isWidget?: boolean;
  isInteractive?: boolean;
}) => (
  <RadarChart
    id={id}
    loadableSelectedGamesAtom={loadablePlayerSelectedGamesForQueryAtom}
    loadableRadarDataAtom={loadablePlayerRadarDataAtom}
    comparisonRadarDataAtom={playerRenderedComparisonSourceAtom}
    isWidget={isWidget}
    isInteractive={isInteractive}
  />
);
